import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

// Get StudentApplication
export const StudentStatistics = createAsyncThunk('student-statistics', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/student/statistics')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentCounts = createAsyncThunk('std-statistics', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/student-application/statistics')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get StudentApplication
export const ListStudentApplication = createAsyncThunk(
  'student-application-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/student-application/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create StudentApplication
export const CreateStudentApplication = createAsyncThunk(
  'student-application-create',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/student-application/store', data)
      return response.data
    } catch (error: any) {
      const message =
        error.response?.data?.errors ?? error.response?.data ?? error.message ?? 'Unknown error'
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// Get StudentApplication by id
export const EditStudentApplication = createAsyncThunk(
  'student-application-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`api/student-application/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete StudentApplication
export const DeleteStudentApplication = createAsyncThunk(
  'student-application-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/student-application/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete StudentApplication
export const GetProgramPayments = createAsyncThunk(
  'program-payments',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/student-application/program-payment/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Toggle Archive StudentApplication
export const toggleArchiveStudentApplication = createAsyncThunk(
  'application-toggle',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/student-application/toggle-archive/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// ListArchivedApplicationStudent
export const ListArchivedApplicationStudent = createAsyncThunk(
  'archived-student-application-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/student-application/archived-list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// view viewStudentApplication
export const viewStudentApplication = createAsyncThunk(
  'application-student-view',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-application/view/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentApplicationLetters = createAsyncThunk(
  'student-app-letters',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-application/letters/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// PrintApplicationLetter
export const AppLetterView = createAsyncThunk('app-letter-prt', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/student-application/show-letter/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Student
export const ListStudent = createAsyncThunk('student-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/student/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Student
export const DeleteStudent = createAsyncThunk('student-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/student/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Toggle Archive Student
export const toggleArchiveStudent = createAsyncThunk(
  'student-toggle',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/student/toggle-archive/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// view viewStudent
export const viewStudent = createAsyncThunk(
  'student-view',
  async ({id, stdId}: {id: string; stdId: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student/view/${id}/${stdId}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Update Student
export const UpdateStudent = createAsyncThunk('student-update', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student/update', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Student by id
export const EditStudent = createAsyncThunk('student-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`api/student/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const EditStudentPayment = createAsyncThunk(
  'student-edit-payment',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`api/student/edit-payment/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const UpdateStudentPayment = createAsyncThunk(
  'update-payment',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/student/update-payment', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Email student
export const emailStudent = createAsyncThunk('student-email', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student/email', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// ListArchivedStudent
export const ListArchivedStudent = createAsyncThunk(
  'archived-students',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/student/archived-list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentDocument
export const ListStudentDocument = createAsyncThunk(
  'student-documents',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-document/list/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create StudentDocument
export const CreateStudentDocument = createAsyncThunk(
  'student-document-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/student-document/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentDocument by id
export const EditStudentDocument = createAsyncThunk(
  'student-document-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`api/student-document/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete StudentDocument
export const DeleteStudentDocument = createAsyncThunk(
  'student-document-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/student-document/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentNote
export const ListStudentNote = createAsyncThunk('student-notes', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-note/list/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create StudentNote
export const CreateStudentNote = createAsyncThunk(
  'student-note-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/student-note/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentNote by id
export const EditStudentNote = createAsyncThunk(
  'student-note-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`api/student-note/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete StudentNote
export const DeleteStudentNote = createAsyncThunk(
  'student-note-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/student-note/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete StudentNote
export const StudentInvoices = createAsyncThunk(
  'student-invoices',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`api/student/invoice/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentApplication by id
export const GetRegAppEmail = createAsyncThunk('ge-reg-app-email', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`api/student-application/get-reg-app-email/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create StudentApplication
export const AppEmail = createAsyncThunk('application-email', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/student-application/send-reg-app-email', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete letter
export const DeleteLetter = createAsyncThunk('letter-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/student-application/destroy-letter/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StdLetterDelete = createAsyncThunk(
  'std-letter-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/student/destroy-letter/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// View Letter
export const ViewStudentLetter = createAsyncThunk(
  'view-student-letter',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student/show-letter/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create Letter
export const CreateStudentLetter = createAsyncThunk('create-letter', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/student/create-letter', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Toggle Archive student
export const toggleStudentLetter = createAsyncThunk(
  'student-letter-toggle',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/letter/toggle-visibility/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentProfile = createAsyncThunk('std-profile', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`api/std/my-profile`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentCard = createAsyncThunk('std-card', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`api/std/my-card`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentDocument = createAsyncThunk('std-documents', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`api/std/my-document`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentLetter = createAsyncThunk('std-letters', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`api/std/my-letters`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MyVids = createAsyncThunk('std-my-videos', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/std/video-library')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SearchVideos = createAsyncThunk(
  'std-video-search',
  async ({type, program, section}: {type: string; program: string; section: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/std/video-search/${type}/${program}/${section}`)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListMyPub = createAsyncThunk('my-pub-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/std/pub-list')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create publication
export const createMyPub = createAsyncThunk('my-pub-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student/pub-store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListPub = createAsyncThunk(
  'student-publication-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/student/publ-list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const MyInvoices = createAsyncThunk('my-invoices', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/std/my-invoices')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentRegulations = createAsyncThunk('std-regulations', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/std/regulations')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentNews = createAsyncThunk('std-news', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/std/my-news')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StduentCourses = createAsyncThunk('std-courses', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/std/my-courses')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MyAttendance = createAsyncThunk('my-attendance', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/std/my-attendance/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerInfo = createAsyncThunk('lecturer-info', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/std/lecturer-info/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MyTranscript = createAsyncThunk('my-transcript', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/std/my-transcript')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const Alumnistudent = createAsyncThunk('alumni-student', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student/alumni/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListAlumniStudents = createAsyncThunk(
  'alumni-student-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/student/alumni-list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const AlumniStudentDetails = createAsyncThunk(
  'alumni-student-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student/alumni-details/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentUpgrade = createAsyncThunk('upgrade-student', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/student/student-upgrade', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SubmitStudentAssignment = createAsyncThunk(
  'std-submit-assignment',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/std/store-assignment', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const MyTranscriptPrint = createAsyncThunk(
  'transcript-print-std-portal',
  async ({lang, studentId}: {lang: string; studentId: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/std/transcript-print/${lang}/${studentId}`)
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentTranscriptPrint = createAsyncThunk(
  'std-transcript-print-admin',
  async ({lang, studentId}: {lang: string; studentId: string}, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student/transcript-print/${lang}/${studentId}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentTranscript = createAsyncThunk(
  'std-transcript-admin',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student/transcript/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetCourseEvaluationDetails = createAsyncThunk(
  'get-course-ev-details',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/std/get-course-ev-form/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StoreEvaluationForm = createAsyncThunk('ev-form-store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/std/ev-form-store', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StdEvaluationFromGraph = createAsyncThunk('ev-graph', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/std/ev-form-graph/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentAnnualFeedback = createAsyncThunk(
  'std-annual-feedback',
  async (_, thunkAPI) => {
    try {
      const response = await axios.get('/api/std/annual-form')
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetAnnualFeeback = createAsyncThunk(
  'get-std-annual-feedback',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/std/get-annual-form/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StoreAnnualForm = createAsyncThunk('ev-form-store', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/std/annual-form-store', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateAppLetter = createAsyncThunk('create-app-letter', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/student-application/create-letter', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MoveAppToStdudent = createAsyncThunk('move-app-to-std', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/student-application/move-app-to-stds', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ArchiveApps = createAsyncThunk('archive-apps', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/student-application/archive-apps', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAppList = createAsyncThunk('get-app-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-application/get-app-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStdList = createAsyncThunk('get-std-list', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student/get-students`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStudents = createAsyncThunk('get-students', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student/get-student-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAyStds = createAsyncThunk('ay-students', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student/get-ay-students/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetIntakeProStd = createAsyncThunk(
  'intake-pro-students',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/student/intake-pro-students', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetAyProStudent = createAsyncThunk(
  'get-pro-ay-students',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/student/get-pro-ay-students', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CreateUserForStds = createAsyncThunk(
  'create-user-for-std',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/student/create-user', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SkipEvForm = createAsyncThunk('skip-ev-form', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/std/skip-evaluation-form/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ApplicationLetterEmail = createAsyncThunk(
  'app-letter-mail',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student-application/email-app-letter/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentLetterEmail = createAsyncThunk(
  'std-letter-mail',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student/email-letter/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ImportExcelStudents = createAsyncThunk(
  'import-student-excel',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/student-application/import-excel', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StdRelatedPrograms = createAsyncThunk(
  'std-related-programs',
  async (
    {academic_year_id, intake_id}: {academic_year_id: string; intake_id: string},
    thunkAPI
  ) => {
    try {
      const response = await axios.get(
        `/api/student/related-programs/${academic_year_id}/${intake_id}`
      )
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CreateGroupLetter = createAsyncThunk(
  'create-group-letter',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/student-application/create-group-letter', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const UpdateAndEmailStdAccount = createAsyncThunk(
  'update-account-and-mail',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/student/update-email-account/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const RelatedStudents = createAsyncThunk('related-students', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/student/related-students', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateGroupLetterStd = createAsyncThunk(
  'create-group-letter-std',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/student/create-group-letter', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EditStdProfile = createAsyncThunk('edit-profile', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/std/edit-profile')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const updateStdProfile = createAsyncThunk(
  'update-std-profile',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/std/udpate-profile', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OnlineApplications = createAsyncThunk('online-apps', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/student-application/online-applications', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OnlineApplicationDelete = createAsyncThunk(
  'online-app-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/student-application/online-app-destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OnlineApplication = createAsyncThunk('online-app', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-application/online-app/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ChangeOnlineApp = createAsyncThunk(
  'change-online-app',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`api/student-application/change-to-app/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ChangeOnlineApplication = createAsyncThunk(
  'change-online-application',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/student-application/change-to-application', data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListStudentCard = createAsyncThunk(
  'student-card-list',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/std-card/list/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create StudentApplication
export const CreateStudentCard = createAsyncThunk(
  'student-card-create',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/std-card/store', data)
      return response.data
    } catch (error: any) {
      const message =
        error.response?.data?.errors ?? error.response?.data ?? error.message ?? 'Unknown error'
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// Get StudentCard by id
export const EditStudentCard = createAsyncThunk(
  'student-card-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`api/std-card/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const InactiveStudentcard = createAsyncThunk(
  'inactive-student-card',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/std-card/inactive/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetAyApps = createAsyncThunk('get-ay-apps', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-application/get-ay-apps/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete StudentCard
export const DeleteStudentCard = createAsyncThunk(
  'student-card-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/std-card/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetAyProApps = createAsyncThunk('getAyProApps', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student-application/get-pro-ay-apps', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetIntakeProApps = createAsyncThunk('intake-pro-apps', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student-application/intake-pro-apps', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAyStudents = createAsyncThunk('get-ay-stds', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student/get-ay-stds/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetIntakeProStds = createAsyncThunk('intake-pro-stds', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student/intake-pro-stds', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAyProStudents = createAsyncThunk('getAyProStudents', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student/get-pro-ay-stds', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const Planning = createAsyncThunk('planning', async (_, thunkAPI) => {
  try {
    const res = await axios.get('/api/std/planning')
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentStatistic = createAsyncThunk('std-statistics', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/student/std-statistics', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ProStudents = createAsyncThunk('pro-stds', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student/student-program/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const BackAsStudent = createAsyncThunk('back-as-std', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student/back-as-std/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintStudents = createAsyncThunk('print-students', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/student/print-students', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentExcel = createAsyncThunk('student-excel', async (params: {}) => {
  const response = await axios.get('/api/student/excel-students', {
    params,
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'Student List.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

export const SkipStdAnnForm = createAsyncThunk('skip-std-ann-form', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/std/skip-ann-form', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StdFinancialStatus = createAsyncThunk('financial-status', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/std/financial-status')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const EmailToApplications = createAsyncThunk('email-to-apps', async (data: {}, thunkAPI) => {
  try {
    const response = await axios.post('/api/student-application/email-to-apps', data)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// email to archived applications options
export const ArchivedApps = createAsyncThunk('get-archived-apps', async (_, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-application/get-archived-apps`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ArchivedAyApps = createAsyncThunk('archived-ay-apps', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-application/archived-ay-apps/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const IntakeProArcApps = createAsyncThunk('int-pro-arc-apps', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student-application/int-pro-arc-apps', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const AyProArcApps = createAsyncThunk('pro-ay-arc-apps', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student-application/pro-ay-arc-apps', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const checkEmergencyContact = createAsyncThunk('check-em-contact', async (_, thunkAPI) => {
  try {
    const res = await axios.get('/api/std/check-em-contact')
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const storeEmergencyContact = createAsyncThunk(
  'store-em-contact',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/std/store-em-contact', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SwitchStdAccount = createAsyncThunk('switch-account', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student/switch-account/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const InactiveStdAccounts = createAsyncThunk(
  'inactive-accounts',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`/api/student/inactive-accounts`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type StudentState = {
  record: any
  records: any
  errors: any
}

const initialState: StudentState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}
export const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(ListStudentApplication.fulfilled, (state, action: PayloadAction<any>) => {
      state.records = action.payload
    })
    builder.addCase(
      ListArchivedApplicationStudent.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.records = action.payload
      }
    )
    builder.addCase(ListStudent.fulfilled, (state, action: PayloadAction<any>) => {
      state.records = action.payload
    })
    builder.addCase(ListArchivedStudent.fulfilled, (state, action: PayloadAction<any>) => {
      state.records = action.payload
    })
    builder.addCase(ListAlumniStudents.fulfilled, (state, action: PayloadAction<any>) => {
      state.records = action.payload
    })
  },
})

export const {reset} = studentSlice.actions
export default studentSlice.reducer
